import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserModel} from "../../../../../../models/user.model";
import {DataTableDirective} from "angular-datatables";
import {Subject} from "rxjs";
import {environment} from "../../../../../../../environments/environment";
import {UserRole} from "../../../../../../enums/user-role";
import {ToastsService} from "../../../../../../services/toasts.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-shipments-list',
  templateUrl: './shipments-list.component.html',
  styleUrls: ['./shipments-list.component.scss']
})
export class ShipmentsListComponent implements OnInit {
  @Input('lengthMenu') lengthMenu;
  @Input('pageLength') pageLength;
  @Input('criteria') criteria;
  @Input('userRole') userRole;

  selectedClients: any[] = [];
  apiUrl: any = null;

  timeout: number = 100;
  goToLocker: boolean = false;


  dtTranslation:any = null;

  shipments: any[] = [];
  dOptions: any = null;
  lastEvent: any = null;
  public dtInit: boolean = false;
  lastEventProcessing: boolean = false;

  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective, {static: false}) dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};

  constructor(
    private router: Router,
    private http: HttpClient,
    toastsService: ToastsService,
  ) {
    this.apiUrl = environment.api;
    this.dtTranslation = toastsService.dtTranslation;
  }

  ngOnInit(): void {
    setTimeout(
      (): void => {
        this.shipments = [];
        this.showShipments();
    }, 500);
  }

  cleanShowShipments(): void {
    var table: DataTables.Api = $('#shipmentListTable').DataTable();
    table.search('').draw();
    table.page(0);
    this.lastEvent = null;
    this.shipments = [];
    this.showShipments();
  }

  showShipments(): void {
    if (this.selectedClients.length > 0) {
      this.criteria.client_ids = [];
      for (let selectedClient of this.selectedClients) {
        this.criteria.client_ids.push(selectedClient.id);
      }
    }

    if (null !== this.lastEvent) {
      clearTimeout(this.lastEvent);
    }

    if (true === this.lastEventProcessing) {
      setTimeout(
        (): void => {
            this.showShipments();
          }, 200
      );

      return;
    }

    this.lastEvent = setTimeout(
      (): void => {
        const that: this = this;
        that.lastEventProcessing = true;
        let cl = [];
        if (this.userRole < 3) {
          cl = [
            {data: 'internal_waybill', name: 's.internal_waybill'},
            {data: 'recipient_name', name: 's.recipient_name'},
            {data: 'client_name', name: 'c.name'},
            {data: 'recipient_locality', name: 's.recipient_locality'},
            {data: 'out_waybill', name: 's.out_waybill'},
            {data: 'declared_content', name: 's.declared_content'},
            {data: 'cash_on_delivery_value', name: 's.cash_on_delivery_value'},
            {data: 'created_at', name: 's.created_at'}
          ];
        } else {
          cl = [
            {data: 'internal_waybill', name: 's.internal_waybill'},
            {data: 'recipient_name', name: 's.recipient_name'},
            {data: 'recipient_locality', name: 's.recipient_locality'},
            {data: 'out_waybill', name: 's.out_waybill'},
            {data: 'declared_content', name: 's.declared_content'},
            {data: 'cash_on_delivery_value', name: 's.cash_on_delivery_value'},
            {data: 'created_at', name: 's.created_at'}
          ];
        }
        if (!this.dtInit) {
          setTimeout(
            (): void => {
              this.dtTrigger.next();
            }, 0
          );
        } else {
          this.dtElement.dtInstance.then(
            (dtInstance: DataTables.Api): void => {
              try {
                dtInstance.destroy();
                this.dtTrigger.next();
                this.dtInit = false;
              } catch (e) {
              }
            }
          );
        }

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: this.pageLength,
          lengthMenu: this.lengthMenu,
          serverSide: true,
          processing: true,
          stateSave: true,
          searchDelay: 250,
          order: [[cl.length - 2, 'DESC']],
          dom: '<"top"il>frt<"bottom"lp><"clear">',
          ajax: (dataTablesParameters: any, callback): void => {
            that.http
              .post(
                this.apiUrl + 'app/v1/parcel/list',// todo zmienić endpoint pod egidą app/v2??
                {
                  ...dataTablesParameters,
                  criteria: this.criteria
                }
              ).subscribe(
                (response: any): void => {
                  this.timeout = 900;
                  that.shipments = response.data;
                  that.dtInit = true;
                  this.lastEvent = null;
                  that.lastEventProcessing = false;

                  callback({
                    recordsTotal: response.recordsTotal,
                    recordsFiltered: response.recordsFiltered,
                    data: []
                  });
            });
          },
          columns: cl,
          language: this.dtTranslation
        };
      }, this.timeout
    );
  }

  setGoToLocker(value): void {
    this.goToLocker = value;
  }

  shipmentCountry(shipment): string {
    if (this.isReturn(shipment)) {
      if (3 === shipment.sender_country_id) {
        return 'Węgry';
      }

      if (4 === shipment.sender_country_id) {
        return 'Bułgaria'
      }
    }
    else {
      if (3 === shipment.recipient_country_id) {
        return 'Węgry';
      }

      if (4 === shipment.recipient_country_id) {
        return 'Bułgaria'
      }
    }

    return 'Rumunia';
  }

  shipmentFlagUrl(shipment): string {
    if (this.isReturn(shipment)) {
      if (3 === shipment.sender_country_id) {
        return this.apiUrl + 'app/v1/asset/flag/HU';
      }

      if (4 === shipment.sender_country_id) {
        return this.apiUrl + 'app/v1/asset/flag/BG';
      }
    }
    else {
      if (3 === shipment.recipient_country_id) {
        return this.apiUrl + 'app/v1/asset/flag/HU';
      }

      if (4 === shipment.recipient_country_id) {
        return this.apiUrl + 'app/v1/asset/flag/BG';
      }
    }

    return this.apiUrl + 'app/v1/asset/flag/RO';
  }

  isReturn(shipment): boolean {
    return 'return' === shipment.type || 'emag_return' === shipment.type;
  }

  goTo(internalWaybill): void {
    if (!this.goToLocker) {
      this.router.navigateByUrl('/shipment/' + internalWaybill);
    }
  }

  protected readonly UserRole = UserRole;
}
